var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.448864 19V5.90909H4.07955V19H0.448864ZM2.27273 4.22159C1.73295 4.22159 1.26989 4.04261 0.883523 3.68466C0.502841 3.32102 0.3125 2.88636 0.3125 2.38068C0.3125 1.88068 0.502841 1.4517 0.883523 1.09375C1.26989 0.730113 1.73295 0.548295 2.27273 0.548295C2.8125 0.548295 3.27273 0.730113 3.65341 1.09375C4.03977 1.4517 4.23295 1.88068 4.23295 2.38068C4.23295 2.88636 4.03977 3.32102 3.65341 3.68466C3.27273 4.04261 2.8125 4.22159 2.27273 4.22159ZM10.6186 11.4318V19H6.98793V5.90909H10.4482V8.21875H10.6016C10.8913 7.45739 11.3771 6.85511 12.0589 6.41193C12.7408 5.96307 13.5675 5.73864 14.5391 5.73864C15.4482 5.73864 16.2408 5.9375 16.9169 6.33523C17.593 6.73295 18.1186 7.30114 18.4936 8.03977C18.8686 8.77273 19.0561 9.64773 19.0561 10.6648V19H15.4254V11.3125C15.4311 10.5114 15.2266 9.88636 14.8118 9.4375C14.397 8.98295 13.826 8.75568 13.0987 8.75568C12.6101 8.75568 12.1783 8.8608 11.8033 9.07102C11.4339 9.28125 11.1442 9.58807 10.9339 9.99148C10.7294 10.3892 10.6243 10.8693 10.6186 11.4318Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.613cbb9cfb744606fb273906310d493d.svg";
export { ForwardRef as ReactComponent };